import { graphql } from '@prophecy/graphql-types/graphql';
export const GuestUserQuery = graphql(`
  query GuestUserQuery($uid: String!) {
    User(uid: $uid) {
      firstName
      lastName
      email
      _id
    }
  }
`);
